export default __webpack_public_path__ + "static/media/kshubLogo.290ffc25.png";